import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Modal, Row, Spinner } from "react-bootstrap";
import { Coin, People, Ticket } from 'iconsax-react';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import MyApiClient from '../../../../api-client/MyApiClient';
import { format } from 'date-fns';
import DEFAULT_USER from "../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../components/Util/oders';

export const ReferralTable = () => {
	const navigate = useNavigate();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [payedReferral, setPayedReferral] = useState(0);

	const data_column = [
		{
			Header: 'Nome e cognome',
			Footer: 'Nome e cognome',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px'
					}}
				  />
				  {row.original.name}
				</div>
			)
		},
		{
			Header: 'Email',
			Footer: 'Email',
			accessor: 'email',
		},
		{
			Header: 'Data di attivazione',
			accessor: 'date',
			disableGlobalFilter: true,
			sortType: dateTimeSort,
		},
	];

	const data_transactions_column = [
		{
			Header: 'Numero DonAction',
			Footer: 'Numero DonAction',
			accessor: 'numberOfReferral',
			disableGlobalFilter: true,
		},
		{
			Header: 'Da data',
			Footer: 'Da data',
			accessor: 'startDate',
  			Cell: ({ value }) => new Date(value).toLocaleDateString('it-IT'),
			disableGlobalFilter: true,
			sortType: dateTimeSort
		},
		{
			Header: 'A data',
			Footer: 'A data',
			accessor: 'endDate',
  			Cell: ({ value }) => new Date(value).toLocaleDateString('it-IT'),
			disableGlobalFilter: true,
			sortType: dateTimeSort
		},
		{
			Header: 'Importo',
			Footer: 'Importo',
			accessor: 'numberOfReferralEarn',
			disableGlobalFilter: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status',
			disableGlobalFilter: true,
			Cell: ({ row }) => {
				return (row && 
				  <div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${row.original.status.class}`}></i>
					<div>
					  {row.original.status.label}
					  {row.original.payedTime && (
						<small className="text-muted d-block">
							Pagato il {new Date(row.original.payedTime).toLocaleDateString('it-IT')}
						</small>
					  )}
					</div>
				  </div>
				);
			},
		},
	];

	const [data_json, setDataJson] = useState(null);
	const [data_transactions_json, setDataTransactionsJson] = useState(null);
	const [referralId, setReferralId] = useState(null);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [customersData, customersDataTransactions, profileData] = await Promise.all([
                        apiClient.getClubReferral(token),
						apiClient.getClubReferralTransactions(token),
						apiClient.getProfile(token)
                    ]);
					setLoadingShowed(false);

					if(profileData && profileData.club && profileData.club.referralId) {
						setReferralId(profileData.club.referralId);
					}


					let data_customers = [];
					if(customersData) {
						customersData.items.forEach(element => {
							
							let createdAt = new Date(element.createdAt);

							let image = null;
							if(element.pictures && element.pictures.length>0 && element.pictures[0].uri) {
								image = element.pictures[0].uri;
							}
							
							let customers_row = {
								"id": element.userId,
								"date": format(createdAt, 'dd/MM/yyyy'),
								"name": element.name,
								"totale": "€ 0.00",
								"email": element.email,
								"imageUrl": image
							};
							data_customers.push(customers_row);
						});
					}
					setDataJson(data_customers);

					let data_transactions = [];
					let totalAmount = 0;
					if(customersDataTransactions) {
						customersDataTransactions.forEach(element => {
							
							let image = null;
							if(element.picture && element.picture.uri) {
								image = element.picture.uri;
							}

							const status = {
								"label": "Pagato",
								"class": "text-success"
							};
							
							let customers_row = {
								"id": element.userId,
								"name": element.name,
								"numberOfReferral": element.numberOfReferral,
								"numberOfReferralEarn": "€ "+(element.numberOfReferral * 10).toFixed(2),
								"imageUrl": image,
								"startDate": element.startDate,
								"endDate": element.endDate,
								"status": status,
								"originalStatus": element.status,
								"transactionEmail": element.transactionEmail,
								"payedTime": element.createdAt ?? null
							};

                            if(element.numberOfReferral>0) {
                                data_transactions.push(customers_row);
								totalAmount += element.amount;
                            }
						});
					}
					setDataTransactionsJson(data_transactions);
					setPayedReferral(totalAmount);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	// La riga apre la scheda del pagamento (pagina, non più finestra) con gli utenti DonAction (03/10/2026)
	function apriPagamento(row) {
		navigate('/struttura/referral/pagamento/' + encodeURIComponent(row.startDate), { state: { pagamento: row } });
	}

	function openDetail(row) {
		navigate('/struttura/clienti/player_profile/'+row.id);
	}

	return (
		<>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className='ps-2'>
                <Card className='col me-3 bd-left-primary'>
                    <Card.Body>DonAction Code
                    <h4 className='mt-3'><Ticket></Ticket>&nbsp;&nbsp;{referralId ? referralId : '-'}</h4>
                    </Card.Body>
                </Card>
                <Card className='col me-3 bd-left-gray'>
                    <Card.Body>Numero player DonAction
                    <h4 className='mt-3'><People></People>&nbsp;&nbsp;{data_json?data_json.length:0}</h4>
                    </Card.Body>
                </Card>
                <Card className='col me-3 bd-left-success'>
                    <Card.Body>Totale guadagno
                    <h4 className='mt-3 text-success'><Coin></Coin>&nbsp;&nbsp;&euro;&nbsp;{data_json?(data_json.length * 10).toFixed(2):0}</h4>
                    <br></br>
                    Provvigioni pagate: {payedReferral?payedReferral.toFixed(2):0} &euro;
                    </Card.Body>
                </Card>
            </Row>

			<TabellaLista
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Player DonAction'}
				hasSearch={true}
				searchPlaceholder={'Cerca per nome o email'}
				hasFilter={false}
				hasAddMore={false}
				data_column={data_column}
				data_json={data_json}
				sort_by={'date'}
                sort_type={'desc'}
			/>

			{/* La riga apre la scheda del pagamento con gli utenti DonAction (prima una finestra) */}
			<TabellaLista
				openRow={(row) => apriPagamento(row)}
				cardTitle={'Pagamenti DonAction'}
				hasSearch={false}
				hasFilter={false}
				hasAddMore={false}
				data_column={data_transactions_column}
				data_json={data_transactions_json}
				sort_by={'startDate'}
                sort_type={'desc'}
			/>
		</>
	)

}
export default ReferralTable;